import recipientConfirmation from './recipientConfirmation';
import type { OnboardingConfig } from './types';

const onboardingGuides: OnboardingConfig[] = [recipientConfirmation];

export default onboardingGuides;
